(function(){
  'use strict';
  const money = (cents) => 'R' + (Number(cents||0)/100).toFixed(2).replace('.00','');
  let cartBusy = false;

  async function getCart(){ const r=await fetch('/cart.js',{headers:{Accept:'application/json'}}); return r.json(); }
  function setCartCount(n){ document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=n); }

  async function updateDiscount(code){
    const body={discount:code||''};
    const r=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    return r.json();
  }

  function bundleSummary(cart){
    const qty=cart.items.reduce((s,i)=>s+i.quantity,0);
    const box=document.querySelector('[data-cart-bundle]');
    if(!box) return;
    if(qty===2) box.innerHTML='<strong>2 NUFRA BUNDLE</strong><br>Original: R498 · Bundle: R349 · <b>YOU SAVE R149</b>';
    else if(qty===3) box.innerHTML='<strong>3 NUFRA BUNDLE</strong><br>Original: R747 · Bundle: R449 · <b>YOU SAVE R298</b>';
    else if(qty>3) box.innerHTML='<strong>NUFRA</strong><br>Bundle pricing applies to 2 or 3 units.';
    else box.innerHTML='<strong>NUFRA</strong><br>Free delivery across South Africa.';
  }

  async function refreshCartUI(){
    const cart=await getCart();
    setCartCount(cart.item_count);
    document.querySelectorAll('[data-cart-subtotal],[data-cart-total]').forEach(el=>el.textContent=money(cart.total_price));
    bundleSummary(cart);
    cart.items.forEach((item,index)=>{
      const row=document.querySelector('[data-cart-line="'+(index+1)+'"] [data-line-qty]');
      if(row) row.textContent=item.quantity;
    });
    return cart;
  }

  async function changeLine(line, quantity){
    if(cartBusy) return;
    cartBusy=true;
    try{
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})});
      const cart=await getCart();
      const total=cart.items.reduce((s,i)=>s+i.quantity,0);
      const code=total===2?'NUFRA2PACK':total===3?'NUFRA3PACK':'';
      await updateDiscount(code);
      await refreshCartUI();
      if(quantity===0 || !document.querySelector('[data-cart-line="'+line+'"]')) window.location.reload();
      else window.location.reload();
    } finally { cartBusy=false; }
  }

  function initHeader(){
    document.querySelectorAll('[data-nufra-header]').forEach(header=>{
      const toggle=header.querySelector('.nufra-menu-toggle');
      const nav=header.querySelector('.nufra-mobile-nav');
      if(!toggle||!nav||toggle.dataset.bound==='1') return;
      toggle.dataset.bound='1';
      const close=()=>{toggle.setAttribute('aria-expanded','false');nav.hidden=true;};
      toggle.addEventListener('click',e=>{e.stopPropagation();const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.hidden=open;});
      nav.addEventListener('click',e=>{if(e.target.closest('a')) close();});
      document.addEventListener('click',e=>{if(!header.contains(e.target)) close();});
      document.addEventListener('keydown',e=>{if(e.key==='Escape') close();});
    });
  }

  async function addOffer(button){
    if(cartBusy) return;
    cartBusy=true; button.disabled=true;
    try{
      const variantId=Number(button.dataset.variantId), qty=Number(button.dataset.qty);
      await fetch('/cart/clear.js',{method:'POST',headers:{Accept:'application/json'}});
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:qty}]})});
      if(!r.ok) throw new Error('Add to cart failed');
      const code=qty===2?'NUFRA2PACK':qty===3?'NUFRA3PACK':'';
      await updateDiscount(code);
      window.location.href='/cart';
    }catch(e){console.error(e);button.disabled=false;alert('Sorry, we could not add that offer. Please try again.');}
    finally{cartBusy=false;}
  }

  function initOffers(){
    document.querySelectorAll('.nufra-add-offer').forEach(btn=>{
      if(btn.dataset.bound==='1') return; btn.dataset.bound='1';
      btn.addEventListener('click',()=>addOffer(btn));
    });
    document.querySelectorAll('[data-nufra-buy]').forEach(btn=>{
      if(btn.dataset.bound==='1') return; btn.dataset.bound='1';
      btn.addEventListener('click',async()=>{
        const root=btn.closest('[data-nufra-purchase]'); const checked=root.querySelector('input:checked'); const qty=Number(checked.dataset.qty);
        const variantId=Number(root.dataset.variantId);
        if(cartBusy)return; cartBusy=true; btn.disabled=true;
        try{
          await fetch('/cart/clear.js',{method:'POST',headers:{Accept:'application/json'}});
          const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:qty}]})});
          if(!r.ok) throw new Error();
          await updateDiscount(checked.dataset.discount||'');
          window.location.href='/cart';
        }catch(e){btn.disabled=false;alert('Sorry, we could not add that offer. Please try again.');}
        finally{cartBusy=false;}
      });
    });
  }

  function initGallery(){
    document.querySelectorAll('[data-gallery]').forEach(gallery=>{
      if(gallery.dataset.bound==='1') return; gallery.dataset.bound='1';
      const main=gallery.querySelector('[data-main-image] img'); const thumbs=[...gallery.querySelectorAll('[data-image]')].filter(x=>x.classList.contains('nufra-thumb'));
      let index=0;
      const lightbox=document.createElement('div');
      lightbox.className='nufra-lightbox'; lightbox.hidden=true; lightbox.innerHTML='<button class="nufra-lightbox__close" aria-label="Close">×</button><button class="nufra-lightbox__prev" aria-label="Previous">‹</button><img alt=""><button class="nufra-lightbox__next" aria-label="Next">›</button>';
      document.body.appendChild(lightbox);
      const lbImg=lightbox.querySelector('img');
      const show=i=>{if(!thumbs.length)return; index=(i+thumbs.length)%thumbs.length; const src=thumbs[index].dataset.image; if(main) main.src=src; thumbs.forEach((t,j)=>t.classList.toggle('is-active',j===index));};
      thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
      const open=()=>{if(!thumbs.length)return; lbImg.src=thumbs[index].dataset.image;lbImg.alt='NUFRA product image';lightbox.hidden=false;document.body.style.overflow='hidden';};
      const close=()=>{lightbox.hidden=true;document.body.style.overflow='';};
      gallery.querySelector('[data-lightbox-open]')?.addEventListener('click',open);
      lightbox.querySelector('.nufra-lightbox__close').addEventListener('click',close);
      lightbox.querySelector('.nufra-lightbox__prev').addEventListener('click',()=>{index=(index-1+thumbs.length)%thumbs.length;lbImg.src=thumbs[index].dataset.image;});
      lightbox.querySelector('.nufra-lightbox__next').addEventListener('click',()=>{index=(index+1)%thumbs.length;lbImg.src=thumbs[index].dataset.image;});
      lightbox.addEventListener('click',e=>{if(e.target===lightbox)close();});
      document.addEventListener('keydown',e=>{if(lightbox.hidden)return;if(e.key==='Escape')close();if(e.key==='ArrowLeft')lightbox.querySelector('.nufra-lightbox__prev').click();if(e.key==='ArrowRight')lightbox.querySelector('.nufra-lightbox__next').click();});
    });
  }

  function initCart(){
    document.querySelectorAll('[data-qty-control]').forEach(control=>{
      if(control.dataset.bound==='1')return;control.dataset.bound='1';
      const line=Number(control.dataset.line);
      control.querySelector('[data-qty-minus]')?.addEventListener('click',async()=>{const q=Number(control.querySelector('[data-line-qty]').textContent);await changeLine(line,Math.max(0,q-1));});
      control.querySelector('[data-qty-plus]')?.addEventListener('click',async()=>{const q=Number(control.querySelector('[data-line-qty]').textContent);await changeLine(line,q+1);});
    });
    refreshCartUI().catch(console.error);
  }

  function init(){initHeader();initOffers();initGallery();initCart();}
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:reorder',init);
  document.addEventListener('shopify:section:select',init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();